import { gql } from '@apollo/client';

/**
 * Submit a completed survey (e.g., onboarding questionnaire).
 * Saves answers to the userSurveys collection and sets onboardFormSubmitted=true.
 */
export const SUBMIT_USER_SURVEY = gql`
  mutation SubmitUserSurvey($input: SubmitUserSurveyInput!) {
    submitUserSurvey(input: $input) {
      _id
      formId
      formVersion
      formType
      completedAt
    }
  }
`;

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface SubmitUserSurveyResponse {
  submitUserSurvey: {
    _id: string;
    formId: string;
    formVersion: number;
    formType: string;
    completedAt: string;
  };
}

export interface SubmitUserSurveyVariables {
  input: {
    formId: string;
    formVersion: number;
    formType: string;
    questions: {
      key: string;
      text: string;
      answer: string;
      answerLabel: string;
    }[];
  };
}

// ---------------------------------------------------------------------------
// Mark onboarding seen
// ---------------------------------------------------------------------------

/**
 * Called the moment the onboarding form is displayed.
 * Flips company.hasDoneOnboardingSurvey = true immediately so the form
 * never shows again — regardless of whether the user completes or abandons it.
 */
export const MARK_ONBOARDING_SEEN = gql`
  mutation MarkOnboardingSeen {
    markOnboardingSeen
  }
`;

// ---------------------------------------------------------------------------
// Onboarding invite
// ---------------------------------------------------------------------------

/**
 * Batch-invite users during onboarding. Returns immediately — invites process
 * in the background. One-time: throws ONBOARDING_INVITE_ALREADY_SENT on repeat.
 */
export const INVITE_USERS_ONBOARDING = gql`
  mutation InviteUsersOnboarding($input: InviteUsersOnboardingInput!) {
    inviteUsersOnboarding(input: $input)
  }
`;

export interface InviteUsersOnboardingVariables {
  input: {
    users: {
      name: string;
      email: string;
      role?: string;
      teamId?: string;
    }[];
  };
}
